import { MODULES } from '@/layouts/main/mega-menu/hiddenModules';

/**
 * Modules settings card (OL-135): saves `hidden_modules` as a JSON list of keys.
 * The settings endpoint requires the firm's core fields on every save, so each
 * toggle resends them unchanged (same as AI Features).
 */
const AdvancedSettingsModules = ({ data, onConfirm, loadData, loadDataSave }) => {
  const hidden = Array.isArray(data?.hidden_modules) ? data.hidden_modules : [];
  const busy = loadData || loadDataSave || !data;
  const shown = MODULES.filter((module) => !hidden.includes(module.key)).length;

  const handleToggle = (key) => {
    if (busy) return;

    const next = hidden.includes(key) ? hidden.filter((item) => item !== key) : [...hidden, key];

    const formData = new FormData();
    formData.append('legal_business_name', data.legal_business_name ?? '');
    formData.append('country', data.country ?? '');
    formData.append('date_format', data.date_format ?? '');
    formData.append('time_format', data.time_format ?? '');
    formData.append('hidden_modules', JSON.stringify(next));
    formData.append('_method', 'PUT');
    onConfirm(formData);
  };

  return (
    <div className="card">
      <div className="card-header" id="advanced_settings_modules">
        <h3 className="card-title">Modules</h3>
        <span className="badge badge-sm badge-outline">
          {shown} of {MODULES.length} shown
        </span>
      </div>
      <div className="card-body lg:py-7.5 flex flex-col gap-5">
        <p className="text-xs text-gray-600 max-w-[640px]">
          Switch off the parts of Oak Legal your firm does not use. A switched-off
          module disappears from the menu and from matter and contact pages.
          Nothing is deleted and permissions stay as they are, so you can switch
          it back on at any time.
        </p>

        <div className="flex flex-col divide-y divide-gray-200">
          {MODULES.map((module) => {
            const enabled = !hidden.includes(module.key);

            return (
              <div key={module.key} className="flex items-center justify-between gap-4 py-3">
                <div className="flex flex-col gap-0.5">
                  <span className="text-sm font-medium text-gray-900">{module.label}</span>
                  <span className="text-xs text-gray-500 max-w-[520px]">{module.description}</span>
                </div>
                <label className="switch shrink-0">
                  <input
                    type="checkbox"
                    checked={enabled}
                    onChange={() => handleToggle(module.key)}
                    disabled={busy}
                    aria-label={`Show ${module.label}`}
                  />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { AdvancedSettingsModules };
